"use client";

import { SignOutButton } from "@clerk/nextjs";
import { useEffect } from "react";

import { Button } from "@/components/ui/button";
import { captureClientException } from "@/lib/posthog";

export default function Error({
  error,
  unstable_retry,
}: {
  error: Error & { digest?: string };
  unstable_retry: () => void;
}) {
  useEffect(() => {
    captureClientException(error, {
      tags: {
        source: "app.error",
      },
      extra: {
        digest: error.digest,
      },
    });
  }, [error]);

  return (
    <div className="bg-background flex min-h-screen items-center justify-center">
      <div className="flex max-w-md flex-col gap-6 px-6 text-center">
        <div className="flex flex-col gap-2">
          <h2 className="text-foreground text-xl font-semibold">Algo deu errado</h2>
          <p className="text-muted-foreground">
            Fomos notificados e estamos investigando o problema.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          <Button onClick={unstable_retry}>Tentar novamente</Button>
          <Button
            onClick={() => {
              window.location.href = "/";
            }}
            variant="outline"
          >
            Ir para o início
          </Button>
          <SignOutButton>
            <Button variant="ghost">Sair</Button>
          </SignOutButton>
        </div>
      </div>
    </div>
  );
}
